import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { FilterListMultipleComponent } from './filter-list-multiple.component';

let id = 0;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'filter-checkbox',
  templateUrl: './filter-checkbox.component.html',
  styleUrls: ['./filter-checkbox.component.scss'],
})
export class FilterCheckboxComponent<T> {
  readonly id = `filter-checkbox-${id++}`;

  @Input()
  label: string;

  @Input()
  count: number | null;

  @Input()
  value: T;

  readonly selected = this.filterListMultipleComponent.selected.pipe(
    map(selected => selected?.includes(this.value)),
    distinctUntilChanged(),
  );

  constructor(
    private readonly filterListMultipleComponent: FilterListMultipleComponent<
      string,
      T
    >,
  ) {}

  changeSelected(value: boolean) {
    this.filterListMultipleComponent.changeSelected(this.value, value);
  }
}
